import axios from "../utils/axios";

export const getServiceSettings = async () => {
    const response = await axios.get("/settings/service-page");
    return response.data;
};

export const updateServiceSettings = async (data) => {
    const response = await axios.put("/settings/service-page", data);
    return response.data;
};
